import { type MaybeRefOrGetter, onScopeDispose, type Ref, ref, toRef, watchEffect } from 'vue';

/**
 * Gebruik een robuuste scroll-lock die scrollen verbied middels een overflow: hidden op het <html> root element, die met meerdere locks tegelijk om kan gaan.
 * @param isActive
 */
export const useScrollLock = (isActive: MaybeRefOrGetter<boolean>) => {
  const active = toRef(isActive);
  const isScrollLockActivated = ref(false);

  watchEffect(() => {
    if (active.value) {
      onScrollLockActivated(isScrollLockActivated);
    } else {
      onScrollLockDeactivated(isScrollLockActivated);
    }
  });

  // Ensure scroll lock is deactivated when the component is unmounted
  onScopeDispose(() => {
    onScrollLockDeactivated(isScrollLockActivated);
  });
};

function onScrollLockActivated(isScrollLockActivated: Ref<boolean>) {
  if (isScrollLockActivated.value) return;

  const rootElement = window.document.documentElement as HTMLHtmlElement;

  writeCounterValue(rootElement, parseCounterValue(rootElement) + 1);
  rootElement.classList.add('overflow-hidden');

  isScrollLockActivated.value = true;
}

function onScrollLockDeactivated(isScrollLockActivated: Ref<boolean>) {
  if (!isScrollLockActivated.value) return;

  const rootElement = window.document.documentElement as HTMLHtmlElement;
  const counterValue = parseCounterValue(rootElement);
  writeCounterValue(rootElement, counterValue - 1);

  if (counterValue <= 1) {
    rootElement.classList.remove('overflow-hidden');
  }

  isScrollLockActivated.value = false;
}

function parseCounterValue(rootElement: HTMLHtmlElement) {
  const counter = rootElement.dataset.scrollLockCounter;
  return counter ? Number.parseInt(counter, 10) || 0 : 0;
}

function writeCounterValue(rootElement: HTMLHtmlElement, counterValue: number) {
  rootElement.dataset.scrollLockCounter = Math.max(counterValue, 0).toString();
}
